import { Component } from '@angular/core';

@Component({
  selector: 'app-agent-voice-input',
  // imports: [],
  templateUrl: './agent-voice-input.component.html',
  styleUrl: './agent-voice-input.component.scss'
})
export class AgentVoiceInputComponent {

}
